import { Component, inject, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

// Libs
import { finalize } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// Models
import { UrlCheck } from '../../models/url-check.model';

// Components
import { BadgeStatusComponent } from "../../../shared/components/badge-status/badge-status.component";
import { LoadingButtonComponent } from "../../../shared/components/loading-button/loading-button.component";

// Services
import { UrlService } from '../../services/url.service';


@Component({
  selector: 'app-check-url-modal',
  imports: [ReactiveFormsModule, BadgeStatusComponent, DatePipe, LoadingButtonComponent],
  templateUrl: './check-url-modal.component.html',
  styleUrls: ['../../../shared/components/table/table.component.scss', './check-url-modal.component.scss']
})
export class CheckUrlModalComponent {
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly urlSrv = inject(UrlService);
  activeModal = inject(NgbActiveModal);

  contextId = input<string>();

  loading = false;

  urls!: UrlCheck[];

  selectedRows: any[] = [];

  checkUrlForm: FormGroup = this.fb.group(
    {
      urls: [undefined, [Validators.minLength(4)]],
    }
  );

  onCheck(): void {
    const urls: string[] = this.checkUrlForm.controls['urls'].getRawValue()?.split('\n');
    const contextId = this.contextId();
    if (contextId) {
      this.loading = true;
      this.urlSrv.checkUrlsByContext(contextId, urls)
        .pipe(finalize(() => this.loading = false))
        .subscribe(urls => this.urls = urls);
    }
  }

  isSelected(urlString: string) {
    return this.selectedRows.find(el => el.url === urlString) ? true : false;
  }

  selectRow(url: UrlCheck) {
    if (this.selectedRows.find(el => el.url === url.url)) {
      this.selectedRows = this.selectedRows.filter(el => el.url !== url.url);
    } else {
      this.selectedRows.push(url);
    }
  }

  onRecrawl(): void {
    const urls: string[] = this.selectedRows.map(el => el.url);
    const contextId = this.contextId();
    if (contextId) {
      this.loading = true;
      this.urlSrv.recrawlUrls(contextId, urls)
        .pipe(finalize(() => this.loading = false))
        .subscribe(() => this.activeModal.close());
    }
  }
}
